import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="relative bg-background-100 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            Explorar
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-4">
            Categorias Populares
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Navegue pelas categorias e descubra produtos verificados
          </p>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer"
              data-product-shop
            >
              <img
                src={cat.image}
                alt={`${cat.namePt} - Hoobuy Spreadsheet`}
                title={`${cat.namePt} Hoobuy`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl text-white font-medium mb-1">{cat.namePt}</h3>
                <span className="inline-flex items-center gap-1 text-white/80 text-sm">
                  Ver links <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}